class CustomCursor {
    constructor() {
        this.cursor = null;
        this.cursorHeight = 0;
        this.cursorWidth = 0;
        this.attr = 'data-custom-cursor';
        this.init();
    }

    init() {
        // Check if the cursor already exists
        this.cursor = document.querySelector('.custom-cursor');

        if (!this.cursor) {
            console.log('Cursor element not found. Adding it dynamically.');

            // Create and add the custom cursor
            this.cursor = document.createElement('div');
            this.cursor.classList.add('custom-cursor');
            this.cursor.innerHTML = '<span class="cursor-text"></span>';
            document.body.appendChild(this.cursor);
        }

        // Get height and width of cursor
        this.cursorHeight = this.cursor.offsetHeight;
        this.cursorWidth = this.cursor.offsetWidth;

        // Set initial position of cursor
        this.cursor.style.transform = `matrix(1, 0, 0, 1, ${(window.innerWidth/2) - (this.cursorWidth/2)}, ${(window.innerHeight/2) - (this.cursorWidth/2)})`;

        // Attach global mousemove listener to move the cursor
        document.addEventListener('mousemove', (e) => this.onMouseMove(e));

        // Attach hover effect
        this.attachHoverEffect();
    }

    onMouseMove(e) {
        if (this.cursor) {
            let x = e.clientX - (this.cursorWidth/2);
            let y = e.clientY  - (this.cursorHeight/2);

            this.cursor.style.transform = `matrix(1, 0, 0, 1, ${x}, ${y})`;
        }
    }

    attachHoverEffect() {
        const hoverElements = document.querySelectorAll(`[${this.attr}]`);

        hoverElements.forEach((element) => {
            element.addEventListener('mouseenter', () => this.onMouseEnter(element));
            element.addEventListener('mouseleave', () => this.onMouseLeave());
        });
    }

    onMouseEnter(element) {
        console.log(element);
        if (this.cursor) {
            this.cursor.querySelector('.cursor-text').textContent = element.getAttribute(this.attr) || '';
            this.cursor.classList.add('active');
        }
    }

    onMouseLeave() {
        if (this.cursor) {
            this.cursor.classList.remove('active');
        }
    }
}

export default new CustomCursor();
